import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, FormGroup, FormControl, ControlLabel, Button, ButtonToolbar } from 'react-bootstrap';

import { setNotification } from '../reducers/notification';
import { logIn, logOut, setAdmin } from '../reducers/login';

import { login } from '../services/loginService';

const mapStateToProps = (state, ownProps) => ({
  loggedIn: state.login.loggedIn,
  close: ownProps.close,
  show: ownProps.show
});

const mapDispatchToProps = dispatch => ({
  logIn: user => doLogin(user, dispatch),
  logOut: () => logout(dispatch),
  setAdminStatus: isAdmin => dispatch(setAdmin(isAdmin)),
  showError: () => showError(dispatch)
});

function doLogin(user, dispatch) {
  dispatch(logIn(user));
  dispatch(setNotification('Sisäänkirjautuminen onnistui'));
}

function logout(dispatch) {
  dispatch(logOut());
  dispatch(setNotification('Uloskirjautuminen onnistui'));
  dispatch(setAdmin(false));
}

function showError(dispatch) {
  dispatch(setNotification('Palvelimeen ei saada yhteyttä.'));
}

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: '',
      password: '',
      displayError: false,
      loginDisabled: true
    };

    this.updateUserName = this.updateUserName.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.login = this.login.bind(this);
    this.processLogin = this.processLogin.bind(this);
    this.processClose = this.processClose.bind(this);
  }

  componentWillMount() {
    login().then(this.processLogin).then(this.processClose);
  }

  updateUserName(event) {
    this.setState({
      userName: event.target.value,
      loginDisabled: false
    });
  }

  updatePassword(event) {
    this.setState({
      password: event.target.value,
      loginDisabled: false
    });
  }

  login(e) {
    e.preventDefault();
    login(this.state.userName, this.state.password).catch((err) => {
      this.props.showError();
    }).then(this.processLogin);
  }

  processLogin(loginResponse) {
    if (loginResponse.status === 'error') {
      this.setState({
        displayError: true,
        loginDisabled: true
      });
    } else if (loginResponse.status === 'ok') {
      this.props.close();
      this.props.logIn(loginResponse.user);
      this.props.setAdminStatus(loginResponse.admin);
      this.setState({
        displayError: false,
        loginDisabled: true,
        password: '',
        userName: ''
      });
    }
  }

  processClose() {
    this.setState({ displayError: false });
    this.props.close();
  }

  render() {
    return (
      <Modal show={this.props.show} className="inmodal">
        <Modal.Header>
          <Modal.Title>Varautumisharjoituskalenterin ylläpito</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Kirjaudu sisään luodaksesi uusia harjoitustapahtumia tai muokataksesi kalenterissa olevia.
            Lisätäksesi tai muokataksesi kalenterin tapahtumia sinulla tulee olla tunnukset.
          </p>
          <p>
            Tunnukset myöntää Turvallisuuskomitean sihteeristö.
          </p>
          <form onSubmit={e => this.login(e)}>
            <FormGroup validationState={this.state.displayError ? 'error' : null}>
              <ControlLabel>Käyttäjätunnus</ControlLabel>
              <FormControl type="text" onChange={this.updateUserName} autoFocus />
            </FormGroup>
            <FormGroup validationState={this.state.displayError ? 'error' : null}>
              <ControlLabel>Salasana</ControlLabel>
              <FormControl type="password" onChange={this.updatePassword} />
            </FormGroup>
            <ButtonToolbar>
              <Button type="submit" bsStyle="primary" disabled={this.state.loginDisabled}>
                Kirjaudu
              </Button>
              <Button onClick={this.processClose}>Peruuta</Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

Login.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  logIn: PropTypes.func.isRequired,
  setAdminStatus: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.jsx